export default __webpack_public_path__ + "static/media/credit.15eea0f7.png";